import request from "../../components/request";
import {
  decimalPlaces,
  integerValidation,
  inputValidate,
  CDRatioReset,
} from "./tools";

decimalPlaces("concentration");
integerValidation("concentration");

$("input[type=radio][name=organ]").on("change", function () {
  CDRatioReset();
});

$("#calculate-cd-ratio").on("click", function () {
  const organ = $('input[name="organ"]:checked').val();
  const valueConcentration = $("#concentration").val().replace(",", ".");
  const valueDailyDose = $("#dailyDose").val();

  if (
    valueDailyDose != "Wybierz" &&
    inputValidate(valueConcentration, 0.0, 30.0, "concentration")
  ) {
    $("#cd-ratio-error").removeClass("d-block").addClass("d-none");
    $("#wrapper-cd-ratio").removeClass("d-none");
    $("#loader-cd-ratio").removeClass("d-none").addClass("d-flex");
    $("#data-cd-ratio").addClass("d-none");
    asyncGetDataCDRatio(organ, valueConcentration, valueDailyDose);
  } else {
    $("#wrapper-cd-ratio").addClass("d-none");
    $("#cd-ratio-error")
      .html("Uzupełnij wszystkie pola")
      .removeClass("d-none")
      .addClass("d-block");
  }
});

async function asyncGetDataCDRatio(organ, valueConcentration, valueDailyDose) {
  const CDRatioValue = await request("ratio-calculator", organ, {
    concentration: valueConcentration,
    dailyDose: valueDailyDose,
  });
  setDataCDRatio(CDRatioValue, organ);
}

function setDataCDRatio(CDRatioValue, organ) {
  $("#cd-ratio-name").html(
    organ === "kidney" ? "Przeszczepienie nerki" : "Przeszczepienie wątroby"
  );
  $("#cd-ratio-value").html(
    Number.parseFloat(CDRatioValue.CDRatio).toFixed(2).replace(".", ",")
  );
  if (CDRatioValue.rapidlyMetabolizing) {
    $("#cd-ratio-value").addClass("error");
    $("#cd-ratio-info").addClass("active");
  } else {
    $("#cd-ratio-value").removeClass("error");
    $("#cd-ratio-info").removeClass("active");
  }
  $("#loader-cd-ratio").removeClass("d-flex").addClass("d-none");
  $("#data-cd-ratio").removeClass("d-none").fadeIn(300);
}
